import { stickyTopBarsInset } from 'design-system';
import findSetTitle from './findSetTitle';

const GAP = 8;

const target = (field: Element | null) => (findSetTitle(field) ?? field) as HTMLElement | null;

export const scrollToSet = (field: Element | null) => {
  const element = target(field);
  if (!element) return undefined;
  element.style.scrollMarginTop = `${stickyTopBarsInset() + GAP}px`;
  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return element;
};

export const makeScrollRoom = (field: Element | null) => {
  const element = target(field);
  if (!element) return () => {};
  const root = document.documentElement;
  const previous = root.style.minHeight;
  const scrollTop = window.scrollY + element.getBoundingClientRect().top - (stickyTopBarsInset() + GAP);
  const needed = Math.ceil(scrollTop + window.innerHeight);
  if (needed > root.scrollHeight) root.style.minHeight = `${needed}px`;
  return () => {
    root.style.minHeight = previous;
  };
};

const PANEL_TOP_MARGIN = 8;
const PANEL_BOTTOM_MARGIN = 16;
const MIN_PANEL_HEIGHT = 240;

export const resultsHeight = (field: Element | null) => {
  const title = target(field);
  if (!field || !title) return undefined;
  const fromTitle = field.getBoundingClientRect().bottom + PANEL_TOP_MARGIN - title.getBoundingClientRect().top;
  const available = window.innerHeight - stickyTopBarsInset() - GAP - fromTitle - PANEL_BOTTOM_MARGIN;
  return Math.max(Math.round(available), MIN_PANEL_HEIGHT);
};
